export default "__VITE_PUBLIC_ASSET__f2a5c514__"